import React from "react";
import { getCookie, setCookie } from "../../../lib/utils/cookies";

const SidebarButton = ({
  index,
  isHovered,
  setIsHovered,
  name,
  icon,
  hoverIcon,
  onPress,
  isSelected,
  isCollapsed,
  rightIcon,
}: {
  index: number;
  isHovered: string;
  setIsHovered: React.Dispatch<React.SetStateAction<string>>;
  name: string;
  icon: JSX.Element;
  hoverIcon: JSX.Element;
  onPress: React.MouseEventHandler<HTMLButtonElement> | undefined;
  isSelected: boolean;
  isCollapsed?: boolean;
  rightIcon?: JSX.Element;
}) => {
  const newFeature = getCookie("newFeature")==="true";
  if (newFeature && name === "What's New" && isSelected) {
    setCookie("newFeature","false",7);
  }
  if (isSelected) {
    return (
      <button
        className="rounded-xl focus:ring-0 my-1 flex flex-row justify-between items-center px-5 py-4 md:px-4 md:py-3 lg:px-5 lg:py-4 bg-sbBgHover text-sbTextHover font-semibold"
        key={index}
        onClick={onPress}
      >
        <div className="flex items-center">
        {hoverIcon}
        {!isCollapsed && <p className="ml-4 lg:text-sm">{name}</p>}
        {rightIcon && <span className="ml-auto">{rightIcon}</span>}
        </div>

        {name === "What's New" && newFeature && <div className="bg-blue-700 p-1 rounded-full"></div>}
      </button>
    );
  }
  return (
    <button
      className="rounded-xl bg-white focus:ring-0 text-sbText my-1 flex flex-row justify-between items-center px-5 py-4 md:px-4 md:py-3 lg:px-5 lg:py-4 hover:enabled:bg-sbBgHover hover:text-sbTextHover hover:font-semibold"
      key={index}
      onMouseEnter={() => setIsHovered(name)}
      onMouseLeave={() => setIsHovered("")}
      onClick={onPress}
    >
        <div className="flex items-center">
        {isHovered === name ? hoverIcon : icon}
      {!isCollapsed && <p className="ml-4 lg:text-sm text-left">{name}</p>}
      {rightIcon && <span className="ml-auto">{rightIcon}</span>}
        </div>

      {name === "What's New" && newFeature && <div className="bg-blue-700 p-1 rounded-full"></div>}
    </button>
  );
};

export default SidebarButton;
